import { render, staticRenderFns } from "./MortgageAlternativesPage.vue?vue&type=template&id=0fe6fc0c&scoped=true"
import script from "./MortgageAlternativesPage.vue?vue&type=script&lang=js"
export * from "./MortgageAlternativesPage.vue?vue&type=script&lang=js"
import style0 from "./MortgageAlternativesPage.vue?vue&type=style&index=0&id=0fe6fc0c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fe6fc0c",
  null
  
)

export default component.exports